export default __webpack_public_path__ + "static/media/work.f70346c5.jpg";